import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Icon, { ICON_NAME } from "../../components/Icon";
import LoadingBox from "../../components/LoadingBox";
import Menu from "../../components/Menu";
import modal from "../../components/Popup/ModalCustom";
import { PoiService } from "../../util/services/poi";
import { locationActions } from "../../util/store/location/reducer";
import { selectPermissions } from '../../util/store/selectors';
import { showErrorResponse } from "../../util/varibles/global";
import { IFactory, IPois, ISite } from "../../util/varibles/interface";
import { notify, NotifyCode } from "../../util/varibles/message";
import { ACTION } from '../../util/varibles/permission';
import styles from './style.module.scss';

interface IProps<S> {
    data: S

    onEdit(data: S): void
}

function Action<S extends (ISite | IFactory | IPois)>({ data, onEdit }: IProps<S>) {
    const [loading, setLoading] = useState(false);
    const [canUpdateLocation, canDeleteLocation] = useSelector(selectPermissions([
        ACTION.LOCATION.UPDATE,
        ACTION.LOCATION.DELETE,
    ]));
    const dispatch = useDispatch();

    const handleDelete = useCallback((value: typeof data, loading: boolean) => {
        if (loading)
            return;
        modal.confirm({
            content: `Are you sure delete ${value.name}?`,
            ok: {
                click: () => {
                    setLoading(true)
                    PoiService.delete(value.id || '')
                        .then(() => {
                            setLoading(false);
                            notify.success(NotifyCode.S4)([value.name]);
                            dispatch(locationActions.delete(value.id))
                        })
                        .catch(error => {
                            setLoading(false);
                            showErrorResponse(notify[NotifyCode.E36]([value.name]), error)
                        })
                }
            }
        })
    }, [dispatch]);

    return <div className={styles.action}>
        <Menu
            disabled={loading}
            placement='bottomRight'
            items={[
                canUpdateLocation ? {
                    key: 'edit',
                    label: <div className='menu-line' onClick={() => onEdit(data)}>
                        <Icon icon={ICON_NAME.EDIT} />
                        <div data-lev='name'>Edit</div>
                    </div>
                } : null,
                canDeleteLocation ? {
                    key: 'delete',
                    disabled: loading,
                    label: <div className='menu-line' data-danger={true} onClick={() => handleDelete(data, loading)}>
                        {loading ? <LoadingBox loading={true} spinnerSize={18} /> : <Icon icon={ICON_NAME.DELETE} />}
                        <div data-lev='name'>Delete</div>
                    </div>
                } : null,
            ]}>
            <div className='three-dot' />
        </Menu>
    </div>;
}

export default Action;
